<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="FileTextIcon" />
          <span>Teklif Bilgileri</span>
        </template>
        <offer-view
          :get-data="getData"
          :confirm-offer="confirmOffer"
          :decline-offer="declineOffer"
        />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="UserIcon" />
          <span>Müşteri Bilgileri</span>
        </template>
        <customer-info />
        <customer-invoice />
      </b-tab>
      <b-tab lazy>
        <template #title>
          <feather-icon icon="ClockIcon" />
          <span>Müşteri Geçmişi</span>
        </template>
        <customer-history :customer-id="dataItem.id_customers" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import CustomerInfo from '@/views/Admin/Customers/View/CustomerInfo.vue'
import CustomerInvoice from '@/views/Admin/Customers/View/CustomerInvoice.vue'
import CustomerHistory from '@/views/Admin/Customers/View/CustomerHistory.vue'
import OfferView from '@/views/Admin/Offers/OfferView.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'View',
  components: {
    BTabs,
    BTab,
    CustomerInfo,
    CustomerInvoice,
    CustomerHistory,
    OfferView,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['offers/dataItem']
    },
    saveData() {
      return this.$store.getters['offers/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  beforeCreate() {
    this.$store.commit('offers/RESET_DATA_ITEM')
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('offers/getDataView', { id_offers: this.$route.params.id })
        .then(response => {
          if (response.id_customers) {
            this.getCustomer(response.id_customers)
          }
        })
    },
    confirmOffer() {
      this.$swal({
        title: 'Teklifi onaylamak istiyor musunuz ?',
        text: 'İşlem sonunda teklif durumu Onaylandı olarak değişecektir.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Onayla',
        cancelButtonText: 'İptal',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('offers/offerAppend', {
            id: this.$route.params.id,
            id_offer_statuses: 4,
            id_offers: this.dataItem.id_offers,
            id_projects: this.dataItem.id_projects,
            confirmed: this.moment().format('YYYY-MM-DD H:m:s'),
            confirmed_at: this.userData.id,
          })
            .then(response => {
              if (response.status) {
                this.$swal({
                  icon: 'success',
                  title: 'Teklif Onaylandı.',
                  text: 'Teklif başarı ile onaylandı.',
                  confirmButtonText: 'Kapat',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.getData()
              } else {
                this.$swal({
                  icon: 'XIcon',
                  title: 'Teklif Onaylanamadı.',
                  text: 'Teklif Onaylama işlemi başarılı olamadı.',
                  confirmButtonText: 'Kapat',
                  customClass: {
                    confirmButton: 'btn btn-danger',
                  },
                })
              }
            })
        }
      })
    },
    declineOffer() {
      this.$store.dispatch('offers/saveData', {
        id: this.$route.params.id,
        id_offer_statuses: 5,
        denied: this.moment().format('YYYY-MM-DD H:m:s'),
        confirmed_at: this.userData.id,
      })
        .then(response => {
          if (response) {
            this.getData()
          }
        })
    },
    getCustomer(id) {
      this.$store.dispatch('customers/getDataItem', id)
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
